import { PreferenceSliceActions } from "./preferences.store";

export const { setLanguage, setPreviousDomain } = PreferenceSliceActions;
